export default __webpack_public_path__ + "images/0x767a739d1a152639e9ea1d8c1bd55fdc5b217d7f.png";